
export const getEntidad = async (entidadId: string) => {
  const response = await fetch(`/api/entidad?e=${entidadId}`).then((res) => res.json());
  if (response.error) {
    throw new Error('Entidad no encontrada');
  }
  return response;
};
